import Vue from 'vue'

import 'normalize.css/normalize.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import zhCN from 'element-ui/lib/locale/lang/zh-CN'
import en from 'element-ui/lib/locale/lang/en'
import vi from 'element-ui/lib/locale/lang/vi'
import VCharts from 'v-charts'

import '@/styles/index.scss'

import App from './App'
import router from './router'
import store from './store'
import i18n from './locales'
import { getCurrentLocale } from '@/utils/i18n'

import '@/icons'
import '@/permission'

const elementLocaleMap = {
  zhCN: zhCN,
  en: en,
  zhVIE: vi
}

const savedLocale = getCurrentLocale()
const initialElementLocale = elementLocaleMap[savedLocale] || zhCN

Vue.use(ElementUI, { locale: initialElementLocale })
ElementUI.locale = initialElementLocale

Vue.use(VCharts)

Vue.config.productionTip = false

new Vue({
  i18n,
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js